import { Col, Row } from 'antd';
import { ConfigurePayerEmailInterface, GUTTOR_SPACE } from '../../../shared/constants/commonConstants';
import React, { ReactElement } from 'react';

import FormMultiEmailInput from '../../../shared/components/crmFormElement/FormMultiEmailInput/FormMultiEmailInput';
import CustomTag from '../../../shared/components/customTag/customTag';

export const EmailConfigurationSection = ({
  title,
  placeholder,
  description,
  emailKey,
  emails,
  payerObj,
  onSave,
  onRemove,
  clearEmailField,
  handleKey,
}: ConfigurePayerEmailInterface): ReactElement => (
  <>
    <Row gutter={GUTTOR_SPACE} className={(payerObj?.isPortalCredentialMandatory && (!payerObj?.payerEmailID ||
      payerObj?.credentials?.length === 0)) ? '' : 'PayerEmailConfiguration'}>
      <Col className="m-10 font-12 font-weight-text">
        <div>{title}</div>
      </Col>
    </Row>
    <p className="p-14 font-12">{description}</p>
    <Row gutter={GUTTOR_SPACE} className="flex flex-row align-baseline">
      <Col md={10}>
        <FormMultiEmailInput detail={{
          key: emailKey,
          placeholder,
          hideLabel: true,
          allowClear: false,
          className: 'payerEmail-text',
          onPressEnter: (event: React.KeyboardEvent<HTMLInputElement>): void => {handleKey(event); },
        }} />
      </Col>
      <Col md={1}>
        <a onClick={onSave} className="mouse-pointer bold">SAVE</a>
      </Col>
      <Col onClick={(): any => {clearEmailField(); }}
        md={1} className="bold color-grey mouse-pointer">
        <div>CANCEL</div>
      </Col>
    </Row>
    <Row>
      {emails?.map((email: string, index: number): any => (
        <CustomTag text={email} key={index} removable={true} onRemove={(): void => onRemove(email)} />
      ))}
    </Row>
  </>
);
